/**
 * Scoped CSS for the unified nebula outer glow shell (web).
 */
export const PRESENCE_GLOW_CSS = `
.presence-glow-shell {
  --presence-glow-scale: 1;
  --presence-glow-alpha: 0.08;
  --presence-glow-color: 90, 180, 220;
  --presence-glow-blur: 12px;
  --presence-glow-halo-inset: -30%;
  position: relative;
  display: grid;
  place-items: center;
  overflow: visible;
}
.presence-glow-shell__halo {
  position: absolute;
  inset: var(--presence-glow-halo-inset);
  border-radius: 999px;
  background: radial-gradient(
    circle at 50% 50%,
    rgba(var(--presence-glow-color), var(--presence-glow-alpha)) 0%,
    rgba(var(--presence-glow-color), calc(var(--presence-glow-alpha) * 0.4)) 28%,
    rgba(var(--presence-glow-color), 0) 70%
  );
  filter: blur(var(--presence-glow-blur));
  opacity: 1;
  z-index: 0;
  pointer-events: none;
}
.presence-glow-shell__content {
  position: relative;
  z-index: 1;
  overflow: visible;
}
`;
